var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('template', {
    slot: "subHead"
  }, [_c('sub-visual', {
    attrs: {
      "sh": "Partners",
      "tabActive": "쇼룸·대리점 안내",
      "bg": "/images/sub/visual/sv-partners.jpg"
    }
  })], 1), _c('page-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('partners-list')], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }